const getFbClientId = (cookies) => {
  const fbCookie = cookies.find(cookie => cookie.name === '_fbp')
  if (fbCookie && fbCookie.value) {
    const result = /fb\.1\.\d+\.\d+/.exec(fbCookie.value)
    return result ? result[0] : null
  }
  return null
}

const getFbcCookie = (cookies) => {
  const fbcCookie = cookies.find(cookie => cookie.name === '_fbc')
  if (fbcCookie && fbcCookie.value) {
    const result = /fb\.1\.\d+\.\d+/.exec(fbcCookie.value)
    return result ? result[0] : null
  }
  return null
}

const getGAValue = (cookies) => {
  const gaCookie = cookies.find(cookie => cookie.name === '_ga')
  if (gaCookie && gaCookie.value) {
    const raw = decodeURIComponent(gaCookie.value)
    const match = raw.match(/(\d+\.\d+)$/)
    return match ? match[1] : null
  }
  return null
}

const getSessionGACookies = (cookies) => {
  const gaCookies = cookies.filter(cookie => cookie.name.startsWith('_ga_'))
  const gaCookieValues = {}
  gaCookies.forEach(cookie => {
    gaCookieValues[cookie.name] = cookie.value
  })

  return gaCookieValues
}

const getTTClidCookie = (cookies) => {
  const ttclidCookie = cookies.find(cookie => cookie.name === 'ttclid')
  if (ttclidCookie && ttclidCookie.value) {
    return ttclidCookie.value
  }

  return null
}

const getTTPCookie = (cookies) => {
  const ttpCookie = cookies.find(cookie => cookie.name === '_ttp')
  if (ttpCookie && ttpCookie.value) {
    return ttpCookie.value
  }

  return null
}

const getEpikCookie = (cookies) => {
  const epikCookie = cookies.find(cookie => cookie.name === '_epik')
  if (epikCookie && epikCookie.value) {
    return epikCookie.value
  }

  return null
}

export const getPixelCookies = (cookies) => {
  if (!cookies) return
  const fbp = getFbClientId(cookies)
  const userIdGA = getGAValue(cookies)
  const fbc = getFbcCookie(cookies)
  const sessionIdGA = getSessionGACookies(cookies)
  const ttclid = getTTClidCookie(cookies)
  const ttp = getTTPCookie(cookies)
  const epik = getEpikCookie(cookies)

  const attributesObject = {}

  if (fbp) attributesObject.fbp = fbp
  if (userIdGA) attributesObject.uIdGA = userIdGA
  if (fbc) attributesObject.fbc = fbc
  if (sessionIdGA && Object.keys(sessionIdGA).length > 0) {
    attributesObject.sIdGA = sessionIdGA
  }
  if (ttclid) attributesObject.ttclid = ttclid
  if (ttp) attributesObject.ttp = ttp
  if (epik) attributesObject.epik = epik

  attributesObject.uAg = navigator.userAgent

  const jsonString = JSON.stringify(attributesObject)

  const base64String = btoa(jsonString)

  return `attributes[pixelPinflag]=${base64String}`
}
